import ResourceUpdater from './Modules/ResourceUpdater.js';
import Slider from './Modules/Slider.js';
import ConsentManager from './Modules/ConsentManager.js';

import DitecMobileMenu from './Modules/DitecMobileMenu.js';
import DitecProductNavigation from './Modules/DitecProductNavigation.js';
import DitecOverlayController from './Modules/DitecOverlayController.js';
import DitecProductSlider from './Modules/DitecProductSlider.js';
import DitecFormAccordion from './Modules/DitecFormAccordion.js';
import DitecTabSliderController from "./Modules/DitecTabSliderController";

import '../../../Stylesheets/Frontend/Entry.sass';

document.addEventListener("DOMContentLoaded", function() {

    // In development mode, JS and CSS will be updated in realtime
    //if (document.documentElement.getAttribute('data-environment') !== 'production') {
        new ResourceUpdater({
            //observe: 'Main.js, Main.css',
            observe: 'Main.css',
            debug: false
        });
    //}

    // Init the product 360
    if (document.getElementById('product-360')) {
        (async function() {
            const module = await import("./Modules/DitecProduct360.js");
            new module.default;
        })();
    }

    // Init consent manager
    new ConsentManager({
        debug: false,
        interfaceLayout: ConsentManager.LAYOUT_CENTER,
        fingerprintIcon: false,
        privacyUri: '/data-protection',
        properties: {
            youtube: {
                enableFrames: 'youtube'
            },
            matomo: {
                enableScriptTag: 'matomo',
                label: 'Matomo (Analysetool)',
                uri: '/datenschutz#matomo'
            },
            analytics: {
                id: 'UA-213690366-1',
                label: 'Google Analytics (Analysetool)',
                uri: '/datenschutz#analytics'
            },
        }
    });

    // Init mobile menu
    new DitecMobileMenu(false);

    // Init overlays
    const overlayController = new DitecOverlayController(false);

    // Init tabsliders
    const tabSliderController = new DitecTabSliderController(false);

    // Init product navigation
    new DitecProductNavigation(false);

    // Init form accordion
    new DitecFormAccordion();

    // Init product details (slider)
    new DitecProductSlider(overlayController, tabSliderController, false);

    // Init sliders (not product slider, not tab sliders)
    const sliders = document.querySelectorAll('.slider');
    for (const slider of sliders) {

        const isTabslider = slider.parentNode.classList.contains('tabslider');
        const isProductSlider = slider.parentNode.classList.contains('products--slider');
        const isHomeSlider = 4 === parseInt(document.body.getAttribute('data-uid'));

        if (isTabslider || isProductSlider) {
            continue; // will be handled by DitecProductSlider
        }

        let itemsPerViewBreakpoints = [];

        const isProductTeaserSlider = slider.classList.contains('product-teasers');
        if (isProductTeaserSlider) {
            itemsPerViewBreakpoints = [
                {
                    minWidth: 1024,
                    itemsPerView: 4
                },
                {
                    minWidth: 768,
                    itemsPerView: 3
                },
                {
                    minWidth: 360,
                    itemsPerView: 2
                },
                {
                    minWidth: 1,
                    itemsPerView: 1
                }
            ];
        }

        const autoplay = 1 == slider.getAttribute('data-slider-autoplay');
        const autoplayInterval = isHomeSlider ? 10000 : 5000;

        new Slider(slider, {
            //debug: 'page__main__media',
            autoplay: autoplay,
            autoplayInterval: autoplay && autoplayInterval,
            slideMode: Slider.SLIDE_MODE_ROTATE,
            gesturesWithMouse: true,
            navigation: 1 === parseInt(slider.getAttribute('data-slider-navigation')),
            controls: 1 === parseInt(slider.getAttribute('data-slider-controls')),
            itemsPerViewBreakpoints: itemsPerViewBreakpoints
        });

        const overlay = slider.querySelector('.slider__overlay');
        if (overlay && autoplay) {
            setTimeout(() => {
                overlay.classList.add('-dismissed');
                setTimeout(() => {
                    overlay.style.display = 'none';
                },1500);
            }, 1500);
        }
    }

    // Video uri copy buttons
    const videoUriCopyButtons = document.querySelectorAll('.video-embed .video-header button');
    if (videoUriCopyButtons) {
        for (const button of videoUriCopyButtons) {
            button.addEventListener('click', () => {
                const iframe = button.parentNode.parentNode.querySelector('iframe');
                const uri = iframe.getAttribute('data-src') || iframe.getAttribute('src');
                const input = document.getElementById(button.getAttribute('data-copy'));
                if (input) {
                    input.value = uri;
                    input.select();
                    document.execCommand("Copy");
                }
            });
        }
    }

    // Autoplay header videos cross-browser
    const headerVideo = document.querySelector('#page__main__media video');
    if (headerVideo) {
        headerVideo.play();
    }

    // Scroll-down button
    const scrollDownButton = document.getElementById('scroll-down');
    if (scrollDownButton) {
        scrollDownButton.addEventListener('click', () => {
            window.scrollTo({ top: window.innerHeight, left: 0, behavior: "smooth" });
        });
        const observeScroll = () => {
            if (window.scrollY > 100) {
                document.body.classList.add('-scroll-down-dismissed');
                window.removeEventListener('scroll', observeScroll);
                setTimeout(() => {
                    scrollDownButton.parentNode.removeChild(scrollDownButton);
                }, 1000);
            }
        };
        window.addEventListener('scroll', observeScroll);
    }

    document.documentElement.removeAttribute('data-defer-display');
    document.documentElement.removeAttribute('data-defer-transitions');

    // Captcha bugfix (won't show image on page load for some reason)
    const captcha = document.getElementById('captcha')
    if (captcha) {
        captcha.querySelector('.captcha__reload').dispatchEvent(new Event('click'))
    }

});